import { makeStyles } from '@material-ui/core/styles'
import Color from 'color'

const styles = makeStyles(theme => {
  const pinkColor = Color(theme.palette.pink.main)
  return {
    amountBanner: {
      minHeight: 69,
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      margin: 0,
      padding: theme.spacing(1.625, 2.125),
      paddingRight: theme.spacing(3.25),
      color: 'white',
      background:
        'linear-gradient(130deg, rgba(235,46,107,1) 0%, rgba(26,163,255,1) 100%)',
      fallbacks: {
        background: 'rgb(235,46,107)'
      },
      '& $chip': {
        backgroundColor: 'white',
        color: pinkColor.string()
      },
      '& $bidderName': {
        fontWeight: 800
      },
      '& $bidAmount': {
        fontWeight: 800
      }
    },
    chip: {
      flexGrow: 0,
      flexShrink: 0,
      backgroundColor: pinkColor.alpha('.23').string(),
      marginRight: theme.spacing(2.25),
      color: theme.palette.text.primary,
      minWidth: 62
    },
    amountBannerTypography: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: 9,
      color: 'white',
      fontWeight: 700,
      textTransform: 'uppercase',
      lineHeight: '1rem',
      marginBottom: theme.spacing(0.75)
    },
    bidderName: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: 21,
      fontWeight: 'normal',
      justifySelf: 'flex-end',
      flexGrow: 1,
      lineHeight: '1rem'
    },
    bidAmount: {
      fontFamily: 'Poppins, Open Sans, sans-serif',
      fontSize: 21,
      fontWeight: 'normal',
      lineHeight: '1rem'
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/AmountBanner/styles.js